import Mutations from '../../odata/mutations';

export default { ...new Mutations('accountMap'), ...new Mutations('accountMaps') };
